module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ct"
  }, [_vm._v("\n\t\t\t\t\tTABLE OF CONTENTS ")]), _vm._v(" "), _c('p', {
    staticClass: "ctt",
    staticStyle: {
      "margin-top": "3em"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/preface",
      "id": "preface"
    }
  }, [_c('b', [_c('i', [_vm._v("Preface")])])])]), _vm._v(" "), _c('p', {
    staticClass: "ctt"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter01",
      "id": "ch1"
    }
  }, [_c('b', [_c('i', [_vm._v("Chapter I :Moscow Exchange Year, 1961-62")])])])]), _vm._v(" "), _c('p', {
    staticClass: "ctt"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter02",
      "id": "ch2"
    }
  }, [_c('b', [_c('i', [_vm._v("Chapter II : Wisconsin to St. Petersburg")])])])]), _vm._v(" "), _c('p', {
    staticClass: "ctt"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter03",
      "id": "ch3",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('i', [_vm._v("Chapter III : Moscow")])])])]), _vm._v(" "), _c('p', {
    staticClass: "ctt"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter04",
      "id": "ch4",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('i', [_vm._v("Chapter IV : Moscow to the Caucasus")])])])]), _vm._v(" "), _c('p', {
    staticClass: "ctt"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter05",
      "id": "ch5",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('i', [_vm._v("Chapter V : Georgia and Black Sea")])])])]), _vm._v(" "), _c('p', {
    staticClass: "ctt"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter06",
      "id": "ch6",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('i', [_vm._v("Chapter VI : Odessa, Kiev, and Over the Border")])])])]), _vm._v(" "), _c('p', {
    staticClass: "ctt"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter07",
      "id": "ch7",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('i', [_vm._v("Chapter VII : Stambul to Brussels, 1977")])])])]), _vm._v(" "), _c('p', {
    staticClass: "ctt"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter08",
      "id": "ch8",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('i', [_vm._v("Chapter VIII : By Volga to Kizhi, 1997")])])])]), _vm._v(" "), _c('p', {
    staticClass: "ctt"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter09",
      "id": "ch9",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('i', [_vm._v("Chapter VIII : The Red Goddess in Krasnodar, 1991")])])])]), _vm._v(" "), _c('p', {
    staticClass: "ctt"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter10",
      "id": "ch10",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('i', [_vm._v("Chapter IX : Queuing Up: The West in Krasnodar, 1991")])])])]), _vm._v(" "), _c('p', {
    staticClass: "ctt"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter11",
      "id": "ch11",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('i', [_vm._v("Chapter XI : Krasnodar Once More: 1997")])])])]), _vm._v(" "), _c('p', {
    staticClass: "ctt"
  }, [_c('b', [_c('i', [_c('span', {
    attrs: {
      "href": "#/works_cited",
      "id": "AHxB",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Works Cited")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31f1d30c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents.vue
// module id = 72
// module chunks = 0